import styled from "styled-components";

export const Message = styled.div`
    color: rgba(172, 52, 33, 1);
    font-weight: bold;
    margin: 0.5rem 0;
`;